function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rowHeight = 72;

var getSharedRowStyles = (isSubRow, isLastSubRow, isRowHighlighted) => ({
  display: 'flex',
  height: "".concat(rowHeight, "px"),
  backgroundColor: isSubRow ? isRowHighlighted ? 'brand.lightest' : 'neutral.lightest' : isRowHighlighted ? 'brand.lightest' : 'neutral.white',
  transition: "background-color ".concat(isRowHighlighted ? 0.3 : 0.1, "s ease-in-out"),
  '> [role="cell"]:first-of-type': {
    borderBottom: isSubRow && !isLastSubRow ? 'none' : 'surface.empty'
  }
});

export var tableTheme = {
  baseStyle: _ref => {
    var {
      isSubRow,
      isLastSubRow,
      tableWidth,
      isRowHighlighted,
      isLoading,
      isHeaderSticky
    } = _ref;
    return {
      container: {
        isolation: 'isolate',
        overflowX: isHeaderSticky ? 'initial' : 'auto',
        width: '100%',
        position: 'relative'
      },
      loaderContainer: {
        position: 'absolute',
        backgroundColor: 'neutral.white',
        left: 0,
        height: '100%',
        width: "".concat(tableWidth, "px"),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 'docked'
      },
      table: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      },
      tableBody: {
        position: 'relative',
        height: isLoading ? "calc(5 * ".concat(rowHeight, "px)") : 'auto',
        flexGrow: 1
      },
      tableHead: isHeaderSticky ? {
        position: 'sticky',
        top: 0,
        zIndex: 'sticky'
      } : {},
      headerRow: _objectSpread(_objectSpread({}, getSharedRowStyles()), {}, {
        borderTopRadius: 'l',
        height: 'auto',
        minHeight: '48x'
      }),
      row: _objectSpread({}, getSharedRowStyles(isSubRow, isLastSubRow, isRowHighlighted)),
      clickableRow: _objectSpread(_objectSpread({}, getSharedRowStyles(isSubRow, isLastSubRow, isRowHighlighted)), {}, {
        cursor: 'pointer',
        outlineColor: 'transparent',
        transition: 'outline-color 0.2s ease-in-out',
        _hover: {
          backgroundColor: isSubRow ? 'neutral.lighter' : 'neutral.lightest'
        },
        _active: {
          backgroundColor: isSubRow ? 'neutral.light' : 'neutral.lighter'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '-2px'
        }
      })
    };
  },
  defaultProps: {
    textAlign: 'start',
    isRowHighlighted: false
  }
};
//# sourceMappingURL=_Table.theme.js.map